<template>
    <transition name="modal-fade">
        <div v-if="show" key="modal-key" class="modal-backdrop">
            <div class="modal" tabindex="-1" role="dialog" @pointerdown.self="close" @keyup.esc="close" ref="modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <slot name="header">
                                <h5 class="modal-title" v-text="title"></h5>
                            </slot>

                            <button type="button" class="close" @click="close" aria-label="Close">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <div class="modal-body">
                            <select-list
                                @close="close"
                                :attachmentId="attachmentId"
                                :attachmentType="attachmentType"
                                :detail="detail"
                                :already-added="alreadyAdded"
                                :type-files="typeFiles"
                                :countries="countries"
                                :brand-options="brandOptions"
                                :searched="searched"
                                :selected-type-files="selectedTypeFiles"
                                :selected-brands="selectedBrands"
                                :selected-countries="selectedCountries"
                                :agreement-country="agreementCountry"
                                :access-countries="accessCountries"
                                />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import SelectList from "./SelectList";
import { EventBus } from '../../event-bus.js';

export default {
    name: "SelectModal",
    components: {
        SelectList,
    },
    props: {
        title: { type:String, default:'Select file', required:false},
        attachmentType: { type:String, default:null, required:false },
        attachmentId: { type:Number, default:null, required:false },
        detail: { type:Boolean, default:false, required: false},
        alreadyAdded: { type:Array, default:() => [], required:false},
        searched: { type:String, default:'', required:false},
        brandOptions: { type:Array, required:true},
        typeFiles: { type:Array, default:() => [], required:false},
        countries: { type:Array, default:() =>[], required:false },
        selectedTypeFiles:  { type:Array, default:() => [], required:false},
        selectedBrands: { type:Array, default:() => [], required:false},
        selectedCountries: { type:Array, default:() => [], required:false},
        agreementCountry: { type:Number, default:null, required:false},
        accessCountries: { type:Boolean, required:true}
    },
    data() {
        return {
            show: false,
        }
    },
    created() {
        EventBus.$on('openSelectModal', () => {
            this.show = true;
        });
    },
    beforeDestroy() {
        EventBus.$off('openSelectModal');
    },
    methods: {
        close() {
            this.show = false;
        },
    },
    watch: {
        show(newValue, oldValue) {
            if (newValue) {
                document.body.classList.add('no-scroll');

                this.$nextTick(() => {
                    this.$refs.modal.focus();
                });

                return
            }

            document.body.classList.remove('no-scroll');
        },
    }
};
</script>

<style scoped lang="scss">
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal {
    display: block;
}
.close svg {
    width: 16px;
}
.modal-content {
    border: solid 0px transparent;
     @media(min-width: 576px) {
        max-height: calc(100vh - 3.5rem);
    }
    @media(max-width: 575px) {
        max-height: calc(100vh - 1rem);
    }
}
.modal-header {
    border-bottom: solid 0px transparent;
}
.modal-body {
    max-height: 96vh;
    overflow-y: scroll;
}
.modal-footer {
    border-top: solid 0px transparent;
    justify-content: flex-start;
}
.modal-fade-enter, .modal-fade-leave-to {
    opacity: 0;
}
.modal-fade-enter-active {
    transition: opacity 0.15s ease-out;
}
.modal-fade-leave-active {
    transition: opacity 0.15s ease-out;
}
@media (min-width: 768px) {
    .modal-dialog {
        max-width: 700px;
    }
}
@media (min-width: 992px) {
    .modal-dialog {
        max-width: 900px;
    }
}
@media (min-width: 1200px) {
    .modal-dialog {
        max-width: 1100px;
    }
}
</style>
